<div class="txm-management-wrapper" *ngIf="isTxmFlag">
  <app-loading size="0.5" class="loading-spinner" *ngIf="(isLoading$ | async) && !(masterSlotsLoading$ | async)
   && (isOpcodesLoading$ | async); else wrapper" color="var(--primary-sec-color)"></app-loading>
  <ng-template #wrapper>
    <a class="bread-crumb w-auto" [routerLink]="['../../scheduledashboard']">
        <mat-icon aria-hidden="false" aria-label="Back to Dashboard">chevron_left</mat-icon>
        <span>{{ 'searchCustomer.backToDashboard' | translate}}</span>
    </a>
    <div class='title'>

        <div class='main'>{{ 'navigation.txmManagement' | translate}}</div>
        <div class='sub'>
          <asp-icon name="ic-20-feedback-alert-error.svg" width="1rem"></asp-icon>
          {{ 'txmManagement.pleaseFlagServiceAdvisorsAndTechniciansAsTxmIn' | translate}}
          <a class="servicePersonnel" [routerLink]="['../../','manageadvisors']" ><span>{{ 'servicePersonnel.servicePersonnel' | translate}}</span></a>
        </div>
      </div>
    <div class="top-section">
      <div class="team-management">
      <app-txm-team-management class="team"
      [team]="txmTeam"
      [techniciansCount$] = "unassignedTxmServiceTechniciansCount$"
      [isTxmTeam]="isTxmTeam" [isTeamCreated]="isTeamCreated"></app-txm-team-management>
    </div>
    <div class="opcode-list">
        <div class="title" [ngClass]="((isTeamCreated   && (unassignedTxmServiceTechniciansCount$ | async) < 2) 
        || (validTxmTeam$ | async) || isTxmTeam===false) ? 'extra-margin' : 'margin'">
        {{ 'opcodeServiceManagement.txmOpcodeManagement' | translate }}</div>
        <div [ngClass]="((isTeamCreated   && (unassignedTxmServiceTechniciansCount$ | async) < 2) || 
        (validTxmTeam$ | async) || isTxmTeam===false) ? 'disable-container' : ''">
      <app-txm-opcode-list></app-txm-opcode-list>
        </div>
    </div>
  </div>
    <div class="txm-capacity-container">
      <div class='capacity-header txm-sticky'>
        {{'departmentCapacity.txmCapacitySetup'| translate}}
        <div class="controls">
          <div class="cancel"
          (click)="onCancelClicked()" 
          [ngClass]="isTXMPerDayEdited ||isTXMPerTimePeriodEdited ?'enabled':''">{{'overrideCapacity.cancel'| translate}}</div>
          <div class="save" 
          (click)="onSaveClicked()" 
          [ngClass]="isTXMPerDayEdited ||isTXMPerTimePeriodEdited ?'enabled':''">{{'overrideCapacity.save'| translate}}</div>
      </div>
    </div>
      <div [ngClass]="((isTeamCreated   && (unassignedTxmServiceTechniciansCount$ | async) < 2) ||
       (validTxmTeam$ | async) || isTxmTeam===false) ? 'disable-container' : ''">
      <div style="display: inline-block;margin-bottom: 10px;width:100%; margin-left: 1rem;">
        <app-transport-max [viewMode]="viewMode" [transportMaxTotal$]="txmTeamMaxTotal$ | async"
        (saveChanges)="onTotalSaveChanges($event)" 
        [switchInput]="true"
        [saveClicked]="isTXMMaxSlotsDaySaveClicked"
        [cancleClicked]="isCancelClicked"
        (formEdited)="txmPerDayFormEdited($event)"
        (cancleClick)="resetCancleClickValue($event)"
        (saveClick)="resetSaveClickedValue($event)">
        </app-transport-max>
      </div>

      <div style="display: inline-block;margin-bottom: 10px;width:100%;padding:0 1rem 0 1rem;">
        <div style="float: left;">
            <div>
              {{'departmentCapacity.txmTeamMaxSlotsPerTimePeriod'| translate}}
            </div>
        </div>
        <div style="float: right;margin-right: 20px;">
            <div style="float: left;font-size: 12px;padding-right: 5px;padding-top: 4px;">{{'departmentCapacity.activate'| translate}}</div>
            <div style="float: right;">
                <app-onofswitch  [switchInput]='txmActivate' (switchChange)="updateSwitchValues($event, 'txm')"></app-onofswitch>
            </div>
        </div>
    </div>
      <div style="padding:1rem">
          <app-timeslot-grid *ngIf="masterSlotsLoading$ | async"
              [viewMode]="viewMode"
              [slotDetails$] = "slotDetails$ | async"
              [maxAndMasterSlots$] = "maxAndMasterSlots$ | async"
              (saveChanges)="onSlotsSaveChanges($event)"
              [switchInput]='txmActivate'
              [saveClicked]="isSavedClicked"
              (formEdited)="txmPerTimePeriodEdited($event)"
              [cancleClicked]="isTXMMaxSlotsPerTimePeriodCancleClicked"
              (cancleClick)="resetCancleClickedAppTable($event)"
              [department]="department">
              </app-timeslot-grid>
      </div>
      </div>
    </div>
  </ng-template>

</div>